<template>
    <div>Redirecting...</div>
</template>

<script>
    export default {
        data() {
            return {                
            }
        },
        methods: {
            logout() {
                this.$auth.logout();
                this.$router.push('/login');
            }
        },
        mounted() {
            this.logout();
        }
    }
</script>